export enum WorkflowFinaliseReason {
  Completed = 1,
  Rejected = 2,
  Withdrawn = 3
}
